import type { UiStrings } from '../types'

const zhTW: UiStrings = {
  brand: 'Holecard EX',
  docTitleSuffix: '過程記錄',
  tagline: '記錄座位·手牌·牌面·線路過程 — 可分享過程卡',
  metaDescription: 'Holecard EX — 行動裝置友善的撲克過程記錄。記錄座位、手牌、牌面與各街行動，產生可分享過程卡。',
  stepsAria: '步驟',
  prev: '返回',
  undo: '復原',
  next: '下一步',
  nextSummary: '查看摘要',
  privacyLink: '隱私與廣告政策',
  privacyTitle: '隱私與廣告政策',
  privacyHint: 'AdSense 審核用草稿。正式上線前請檢視並更新。',
  privacyBack: '返回應用',
  privacyCollectTitle: '1. 我們收集的資訊',
  privacyCollectBody: 'Holecard EX 目前僅在瀏覽器組裝牌譜草稿。無需登入，手牌資料不會傳送到伺服器。草稿可能暫時保存在此分頁的 sessionStorage（若日後變更會更新本政策）。',
  privacyAdsTitle: '2. Cookie 與廣告',
  privacyAdsBody: '可能使用 Google AdSense 等第三方廣告網路。廣告商可能使用 Cookie 或裝置識別碼投放興趣導向廣告。您可在瀏覽器或 Google 廣告設定中控制個人化廣告。',
  privacyContactTitle: '3. 聯絡',
  privacyContactBody: '政策相關問題請至 holdcard-ex.com 的 GitHub 開 issue。營運者信箱：專案設定中的 TODO_OPERATOR_EMAIL。',
  langAria: '語言',
  langCompactAria: '語言（精簡）',
  koPathLink: '한국어',
  koPathLinkAria: '韓文版 (/ko)',
  enPathLink: 'English',
  enPathLinkAria: '英文版 (/)',
  setupTitle: '牌桌',
  setupHint: '人數·籌碼·盲注 — 接著座位 → 手牌 → 線路',
  players: '人數',
  playersUnit: (n) => `${n}人`,
  sb: 'SB',
  bb: 'BB',
  ante: 'Ante（選填）',
  anteHint: '與盲注相同單位',
  effectiveStack: '有效籌碼（BB，選填）',
  potBb: '底池（BB，選填）',
  metaOptionalHint: 'Ante／有效籌碼／底池留空則不顯示於摘要',
  setupDetailsToggle: '人數 · Ante · 有效 · 底池 · 籌碼',
  setupBasicsHint: '預設（6-max · 100bb）即可 — 下一步或跳過',
  setupMetaSetChip: 'Ante · 有效 · 底池已設',
  stackUnit: '籌碼單位',
  stackUnitBb: 'BB',
  stackUnitChips: '籌碼',
  stackChips: '籌碼量（籌碼）',
  stackBb: '籌碼量（BB）',
  stackChipsUnit: '籌碼',
  positionTitle: '座位',
  seatQuestion: '你坐在哪個位置？',
  settingsBack: '返回',
  settingsSegAria: '牌桌設定（人數・盲注・籌碼）',
  lineSeatEditAria: '修改座位',
  lineHoleEditAria: '修改手牌',
  positionHint: (count, hint) => `${count}人桌${hint ? ` · ${hint}` : ''}`,
  tableVizAria: (n) => `${n}人桌座位`,
  tableVizHeroBadge: '我',
  tableVizHeroSeatAria: (seat) => `${seat}（我）`,
  tableVizDealer: 'D',
  tableVizDealerTitle: '莊家按鈕',
  tableVizTapHint: '在牌桌上點選你的座位',
  tableVizListFallback: '座位列表 · 代碼',
  tableVizBlindsAria: (v) => `盲注 ${v}`,
  tableVizPotPlaceholder: '底池',
  tableVizPotValue: (v) => `底池 ${v}`,
  tableVizPotAria: (v) => `底池 ${v}`,
  tableVizStackAria: (v) => `籌碼 ${v}`,
  tableVizEmptyMark: '—',
  tableVizEffHint: (v) => `有效 ${v}bb`,
  tableVizEffTitle: '有效籌碼（全桌共用，非座位各自）',
  tableVizStepDown: '減少',
  tableVizStepUp: '增加',
  tableVizEditDone: '完成',
  tableVizInfoHint: '點桌面盲注、底池或籌碼即可編輯',
  seatAbbrevHint: '座位是縮寫。點一下可看全名。',

  cardsTitle: '手牌',
  cardsHint: '先從我的牌開始 · 對手經「加入對手」· 欄位 · 花色與點數 · 不可重複',
  heroHolesGuide: (seat) => `請選擇 ${seat} 的兩張手牌。`,
  cardSlot1: '牌 1',
  cardSlot2: '牌 2',
  cardSlotSelect: '選擇',
  seatsLabel: '座位',
  knownHolesOptional: '對手手牌為選填（攤牌／回顧 — 可留空）',
  holesBySeat: '手牌 · 選擇座位',
  seatVillain: (pos) => `對手 ${pos}`,
  seatFilled: '已填',
  holesModeHeroOnly: '僅我的牌',
  holesModeWithVillains: '加入對手',
  holesModeAria: '手牌輸入模式',
  villainNudgeToast: '知道對手牌？點 BB／CO 等',
  heroCardsDoneCta: '前往線路',
  heroCardsAddVillainsCta: '加入對手',
  suitPickerLabel: '花色',
  rankPickerLabel: '點數',
  boardTitle: '牌面',
  boardHint: '到了再填 — 僅翻前可略過',
  flop: '翻牌',
  turn: '轉牌',
  river: '河牌',
  flopSlot: (i) => `F${i}`,
  actionsTitle: '線路',
  actionsHint: '各街行動線路 — 棄牌／過牌／跟注／下注／加注／全下',
  actorQuick: '快速行動者',
  actor: '行動者',
  actorPlaceholder: '輸入名稱',
  actorCustomToggle: '自訂名稱',
  actorRequired: '請輸入或選擇行動者',
  action: '行動',
  sizeLabel: '尺度',
  sizePlaceholder: '例：2.5bb',
  sizeRequired: '請輸入下注／加注尺度',
  sizeCustomToggle: '自訂',
  sizeOpenApprox: '開池',
  sizePotApprox: '底池尺寸',
  sizeOverbetApprox: '超池',
  sizeJamApprox: '短碼／全下',
  sizeUnitBb: 'bb',
  sizeUnitPct: 'pot',
  snapHint: '對齊刻度 · ± 一格',
  favoritesLabel: '常用',
  morePresets: '更多預設',
  presetsSizeLabel: '預設 · 尺寸',
  potSizeHintUnset: '在設定中填底池（BB）即可把底池尺寸顯示為 bb',
  clearOptional: '清除',
  betRaiseHint: '下注：尚無攻擊 · 加注：面對下注／加注',
  allinSizeHint: '全下尺度（選填）',
  sizeActionHint: (potBit) => potBit ? `下注=先攻 · 加注=應對 · ${potBit}` : '下注=先攻 · 加注=應對',
  addAction: (street) => `新增${street}行動`,
  updateAction: '更新',
  editAction: '編輯',
  cancelEdit: '取消編輯',
  noStreetActions: (street) => `尚無${street}紀錄。`,
  delete: '刪除',
  moveUp: '上移',
  moveDown: '下移',
  allActionsHint: (n) => `共 ${n} 個行動 · 請查看其他街道分頁`,
  heroChip: (pos) => pos,
  seatOrderHu: 'HU：BTN 兼 SB · 順序 BTN/SB → BB',
  seatOrder: (order) => `座位順序：${order}`,
  positionHintHuBtn: 'HU 按鈕（SB）',
  keepActorHint: '切換街道時保留行動者（僅重設類型／尺度）',
  potQuickPrompt: '快速底池（BB）— 點選以設定並更新提示',
  potQuickClear: '清除底池',
  quickLinesLabel: '快速路線',
  quickLinesHint: '常用模板 — 點選新增',
  macroOpenThenCall: '開池後跟注',
  macroFoldToHero: (seat) => `棄牌至 ${seat}`,
  macroCbet33: 'C-bet ⅓ pot',
  quickLinesSwitchStreet: '切換街道以顯示巨集',
  macroOpenExists: '已記錄開池（加注）',
  macroAlreadyLogged: '開池與跟注已記錄',
  macroFoldToHeroNone: (seat) => `沒有更早的棄牌（或 ${seat} 先行動）`,
  macroFoldToHeroBlocked: '已有更早行動 — 請手動加入棄牌',
  boardCtaFlop: '新增翻牌',
  boardCtaTurn: '新增轉牌',
  boardCtaRiver: '新增河牌',
  quickHand: '快速牌譜',
  skipToCards: '跳到手牌',
  jumpToActions: '前往線路',
  skipBoardPreflop: '略過牌面 — 僅翻前',
  boardSlotsToggle: '加入公牌',
  softStackAria: '目前手牌',
  softStackLine: '行動線',
  softStackHoles: '底牌',
  softStackBoard: '公牌',
  streetTabWithCount: (street, n) => `${street} · ${n}`,
  actionIndexLabel: (n, street) => `行動 ${n} · ${street}`,
  copyLinkTitle: '在 App 中重新開啟這手牌',
  suitStickyHint: '花色維持中 · 點花色可變更',
  suitStickyChip: (s) => `目前花色 ${s}`,
  suitMruLabel: '最近',
  summaryHint: '截圖下方過程卡，或複製／分享文字',
  summaryHole: '手牌',
  summaryBoard: '牌面',
  summaryActions: '行動',
  timelineProcess: '過程',
  timelineBoard: (cards) => `公牌 ${cards}`,
  processMoreSummary: '查看更多過程',
  linePeekSummary: '目前的行動線',
  takeawayLabel: '重點',
  takeawayPlaceholder: '只寫座位與路線 — 例：BTN 加注後 BB 跟注，翻牌過牌',
  takeawayHint: '過程一行 — 僅座位與線路',
  takeawayNudge: '過程一行（選填）\u00a0· 座位·線路',
  takeawayInLinkFact: '過程一行會寫進連結',
  shareSecondarySummary: '備註·對手（選填）',
  shareSecondaryInvite: '留下過程一行（選填）',
  shareMoreSummary: '其他分享',
  lineDraftSummary: '行動者·尺寸',
  explainModeLabel: '說明',
  explainModeAria: '說明模式 — 顯示教學提示',
  reviewScopeLabel: '複盤到',
  reviewScopePreflop: '翻前',
  reviewScopeFlop: '翻牌',
  reviewScopeRiver: '河牌',
  reviewScopeAria: '複盤範圍 — 之後街道收合（不刪除）',
  shareProcessHu: '單挑',
  shareProcessMultiway: '多人底池',
  shareReviewedLabel: '回顧時間',
  summaryCopyLabel: '貼到聊天 — 易讀 + Pro',
  summaryProLabel: 'Pro 記譜',
  emptyDash: '—',
  copyBoth: '分享到聊天',
  copyHuman: '易讀',
  copyPro: 'Pro 記譜',
  copied: '已複製 ✓',
  copiedToast: '摘要已複製',
  screenshotHint: '截圖模式 = 乾淨牌面 · 連結 = 重新開啟這手',
  captureMode: '擷取模式',
  captureExit: '結束擷取',
  saveShareImage: '儲存圖片',
  shareImage: '分享圖片',
  imageSaved: '已儲存 ✓',
  imageShared: '已分享 ✓',
  imageSavedToast: '已儲存圖片',
  imageSharedToast: '已分享圖片',
  imageFailedToast: '無法建立圖片',
  shareText: '分享文字',
  shared: '已分享 ✓',
  copyLink: '複製連結',
  linkCopiedToast: '牌譜連結已複製',
  linkWithoutKnownHolesToast: '連結過長，已略過對手手牌後複製',
  linkTooLongToast: '牌譜過大，無法建立連結',
  sharedToast: '已分享',
  shareFailedToast: '分享失敗',
  newHand: '新牌譜',
  receivedQuietRerecordCta: '用這過程我也來記錄',
  draftRestoredHint: '已還原草稿 — 繼續還是重新開始？',
  draftContinue: '繼續',
  actorFoldedHint: '已棄牌',
  summaryHeading: '[Holecard EX 牌譜摘要]',
  summaryPlayers: (n) => `人數：${n}人`,
  summaryBlinds: (b) => `盲注：${b}`,
  summaryHero: (p) => `座位：${p}`,
  summaryStack: (s) => `籌碼：${s}`,
  summaryEff: (e) => `有效籌碼：${e} BB`,
  summaryPot: (p) => `底池：${p} BB`,
  summaryHoleLine: (h) => `手牌：${h}`,
  summaryHolesHeader: '手牌：',
  summaryKnownHoleLine: (label, cards) => `· ${label}: ${cards}`,
  summaryBoardLine: (b) => `牌面：${b}`,
  summaryActionsHeader: '── 行動 ──',
  summaryFooter: '— 以 Holecard EX 製作',
  summaryProHeader: '── Pro 記譜 ──',
  tableLine: (n, blinds) => `${n}人 · ${blinds}`,
  errorBlinds: '盲注無效。BB 必須 > 0；SB ≥ 0 且 ≤ BB。',
  hintFlopPartial: '翻牌通常為 3 張',
  hintNoActions: '沒有行動也可以 — 「結束紀錄」會分享目前為止的紀錄',
  missingFlopBoard: '有翻牌行動但缺少翻牌',
  missingTurnBoard: '有轉牌行動但缺少轉牌',
  missingRiverBoard: '有河牌行動但缺少河牌',
  boardActionsMismatch: '牌面為空的街道上仍有行動',
  boardNeedFlop: '翻牌為空 — 建議補牌以便回顧',
  boardNeedFlopPartial: '請完成翻牌輸入',
  boardNeedTurn: '轉牌為空 — 建議補上以便回顧',
  boardNeedRiver: '河牌為空 — 建議補上以便回顧',

  softGateTitle: '仍有欄位空白',
  softGateBody: '手牌仍空白。補上手牌以留下過程，或仍要繼續。',
  softGateFix: "新增手牌",
  softGateForceConfirm: "確定要分享未完成內容？",
  softGateMissingHoles: (seat) => `${seat} 手牌（2張）`,
  softGateMissingActions: "至少一個行動",
  softGateBodyLead: "還需要：",
  incompleteBadge: "未完成",
  softGateContinue: '仍要查看摘要',
  softGateShare: '仍要分享',
  softGateCopy: '仍要複製',
  softGateCancel: '返回',
  pickerDisabled: '尚未選擇欄位',
  step: {
    setup: '牌桌',
    position: '座位',
    cards: '手牌',
    board: '牌面',
    actions: '線路',
    summary: '分享',
  },
  street: {
    preflop: '翻前',
    flop: '翻牌',
    turn: '轉牌',
    river: '河牌',
  },
  actionType: {
    fold: '棄牌',
    check: '過牌',
    call: '跟注',
    bet: '下注',
    raise: '加注',
    allin: '全下',
  },
  suit: {
    s: '黑桃',
    h: '紅心',
    d: '方塊',
    c: '梅花',
  },
  positionHintMap: {
    UTG: '槍口',
    "UTG+1": 'UTG+1',
    MP: '中位',
    "MP+1": 'MP+1',
    HJ: '劫持',
    CO: '關煞',
    BTN: '按鈕（莊家）',
    SB: '小盲',
    BB: '大盲',
  },
  progressAria: (current, total, label) =>
    `第 ${current} 步，共 ${total} 步：${label}`,
  adArea: '廣告區',
  adTop: '上方廣告',
  adBottom: '下方廣告',
  adPlaceholderHint: '尚未設定 AdSense ID — 部署前佔位',
  // Softwise M10b: memory-order input
  endHere: "到此結束",
  finishRecord: "結束紀錄",
  reviewAnte: (v) => `前注 ${v}`,
  reviewEffStack: (v) => `有效 ${v}`,
  reviewBreakdownAria: '各街紀錄',
  reviewPlayers: (n) => `${n}人`,
  // vocab-tags:start — screen-only poker vocabulary (review breakdown) (v1 — pending native-player review)
  reviewVocab: {
    trips: '三條面',
    paired: '對子面',
    monotone: '單色',
    twoTone: '雙色',
    rainbow: '彩虹',
    limp: '跛入',
    open: '開池',
    threeBet: '3bet',
    fourBet: '4bet',
    fiveBet: '5bet',
    squeeze: '擠壓',
    coldCall: '冷跟',
    checkRaise: '過牌加注',
    cBet: '持續下注',
    donkBet: '領先下注',
    probeBet: '試探下注',
  },
  shareSavedMark: '已儲存',
  // vocab-tags:end
  flowAskFlop: "翻牌 3 張",
  flowAskTurn: "轉牌 1 張",
  flowAskRiver: "河牌 1 張",
  flowWhoActs: "輪到",
  flowSizeCustom: "自訂",
  flowSizeConfirm: "確認",
  flowSizeLabel: "大小 (bb)",
  flowDone: "行動線已記錄",
  flowRewind: "從這裡重來",
  flowRewindCancel: "取消",
  flowSeatUnrecorded: "未記錄",
  flowSeatNotInvolved: "未參與",
  flowMemoryCut: "之後的不記得了",
  lineStripAria: "目前記錄的行動線",
  // Soft G: optional ending record (L1.5) — seat-subject, press-only, Quiet
  endingSummary: '結局（選填）',
  endingShownLabel: '攤牌時亮出的牌',
  endingPotLabel: '底池',
  endingCardsInput: '輸入牌',
  endingMuck: '未亮牌（蓋牌）',
  endingUnknown: '不明',
  endingPotTo: (seat) => `${seat} 拿下底池`,
  endingSplit: '平分',
  endingLineLabel: '結局',
  endingShownCards: (seat, cards) => `${seat} 亮出 ${cards}`,
  endingShownMuck: (seat) => `${seat} 未亮牌（蓋牌）`,
  endingShownUnknown: (seat) => `${seat} 牌不明`,
  endingPotSplit: '底池平分',
  endingPotUnknown: '底池不明',
  linkWithoutEndingToast: '連結過長，已省略結局後複製',
  linkWithoutTakeawayToast: '連結過長，已省略過程一行後複製',
  endingShownAria: (seat) => `${seat} 攤牌的牌`,
}

export default zhTW
